import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.classListEnd.loading;
export const selectErrorMessage = (state: RootState) =>
  state.classListEnd.error;
export const getClassListResponse = (state: RootState) =>
  state.classListEnd.classListResponse;
